'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getModel;
function getModel(model, state) {
  return typeof model === 'function' && state ? model(state) : model;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-form/lib/utils/get-model.js
 ** module id = 962
 ** module chunks = 0
 **/